(function() {
	'use strict';
	var $ = avm.require('jquery'),
		detect = avastGlobals.detect,
		detectedPlatform = detect.os.name.toLowerCase(),
		$document = $(document),
		supportedPlatforms = ['windows', 'mac', 'android', 'ios'];

	$document.ready(function() {
		var $body = $('body'),
			$popup = $('.js-notification-overlay-for-wrong-download'),
			$downloadButton = $('.js-ab-test-button-oo-14555'),
			$close = $popup.find('.js-close'),
			bodyOverflow = $body.css('overflow');

		$close.on('click', function() {
			$popup.removeClass('show-popup');
			window.location.hash = '!';
			$body.css('overflow', bodyOverflow);
		});

		$popup.on('click', function(event) {
			if ($(event.target).is($popup)) {
				$close.trigger('click');
			}
		});

		$downloadButton.on('click', function(event) {
			if (detectedPlatform !== 'windows') {
				event.preventDefault();
				$popup.addClass('show-popup');
				$popup.addClass('detected-' + (supportedPlatforms.indexOf(detectedPlatform) === -1 ? 'unknown' : detectedPlatform));
				$popup.addClass('install-windows'); // @todo : this should be dynamic if DOWNLOAD button is for other platform then PC
				window.location.hash = 'oops';
				$body.css('overflow', 'hidden');
			}
		});
	});
})();
